import {
  Directive,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { DragAndDropModeService } from '@wilson/shift-timeline/services';
import { firstValueFrom, Subscription } from 'rxjs';
import { MouseMovementHelperService } from '../../services/mouse-movement-helper.service';
import {
  SetDemarcatorRange,
  ShiftTimelineSettingsState,
} from '@wilson/shift-timeline/state';
import { ActivityDropZoneHelperService } from '../activity-drop-zone/activity-drop-zone-helper.service';

@Directive({
  selector: '[wilsonMouseMovementHandler]',
  standalone: true,
})
export class MouseMovementHandlerDirective implements OnInit, OnDestroy {
  private readonly mouseMovementHelperService = inject(
    MouseMovementHelperService,
  );
  private renderer = inject(Renderer2);
  private ngZone = inject(NgZone);
  private store = inject(Store);
  private dragAndDropModeService = inject(DragAndDropModeService);
  private activityDropZoneHelperService = inject(ActivityDropZoneHelperService);

  private subscription!: Subscription;
  private mouseupListener!: () => void;

  @HostListener('mousemove', ['$event']) async onMove(event: MouseEvent) {
    this.subscription =
      this.mouseMovementHelperService.isUserDraggingActivity$.subscribe(
        (isStarted) => {
          if (isStarted) {
            this.mouseMovementHelperService.setMouseOffsetX(event.offsetX);
          } else {
            this.mouseMovementHelperService.setMouseOffsetX(null);
          }
        },
      );
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.mouseupListener = this.renderer.listen('document', 'mouseup', () => {
        firstValueFrom(
          this.mouseMovementHelperService.isUserDraggingActivity$,
        ).then((isUserDraggingActivity) => {
          if (isUserDraggingActivity) {
            this.mouseMovementHelperService.setUserDraggingActivity(false);
            this.mouseMovementHelperService.setMouseOffsetX(null);
            this.activityDropZoneHelperService.setActivity(null);
            this.dragAndDropModeService.setDraggingItemId(null);
            this.dragAndDropModeService.setDisplayMovingDemarcatorLine(false);
            this.dragAndDropModeService.toggleDurationOnDemarcatorLine(false);
            this.dragAndDropModeService.setDisplayTimeVisible(false);
            this.dragAndDropModeService.setIsMovingItemLeftRight(false);
            this.dragAndDropModeService.setTimeDifferenceVisible(true);
            this.dragAndDropModeService.setSnappingStepSize(
              this.store.selectSnapshot(ShiftTimelineSettingsState.zoomLevel),
            );
            this.dragAndDropModeService.setDraggingShiftV2(null);
            this.dragAndDropModeService.setDraggingAbsence(null);
            this.store.dispatch(new SetDemarcatorRange([]));
            this.dragAndDropModeService.setActivityDropZone(false);
            this.dragAndDropModeService.setMoveActivityDropZone(false);
          }
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.mouseupListener();
    this.subscription?.unsubscribe();
  }
}
